import { Origin, ReactionType } from "@/types/common"

export function toOriginX(origin: Origin) {
  switch (origin) {
    case Origin.Start:
      return 'left'
    case Origin.Center:
      return 'center'
    case Origin.End:
      return 'right'
    default:
      return 'center'
  }
}

export function toOriginY(origin: Origin) {
  switch (origin) {
    case Origin.Start:
      return 'top'
    case Origin.Center:
      return 'center'
    case Origin.End:
      return 'bottom'
    default:
      return 'center'
  }
}

export const fugModels = [
  {value: 'PR_TWU', label: 'Peng-Robinson'}
]

export function modalToText(val: string) {
  return fugModels.find(item => item.value === val)?.label || ''
}

export const reactionTypeToOption = () => {
  return [
    {value: ReactionType.Conversion, label: 'Conversion'},
    {value: ReactionType.Equilibrium, label: 'Equilibrium'}
  ]
}
